module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#news",
      toString: function () {
        return this.url;
      }
    }